import React from 'react';

export interface BadgeProps {
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info' | 'orange';
  size?: 'xs' | 'sm' | 'md';
  children: React.ReactNode;
  className?: string;
  title?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  size = 'sm',
  children,
  className = '',
  title,
}) => {
  const variantStyles = {
    default: 'bg-cf-surfaceActive border-cf-border text-cf-textSecondary',
    success: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-600 dark:text-emerald-400',
    warning: 'bg-amber-500/10 border-amber-500/30 text-amber-600 dark:text-amber-400',
    error: 'bg-rose-500/10 border-rose-500/30 text-rose-600 dark:text-rose-400',
    info: 'bg-blue-500/10 border-blue-500/30 text-blue-600 dark:text-blue-400',
    orange: 'bg-cf-orangeMuted border-cf-orange/40 text-cf-orange',
  };

  const sizeStyles = {
    xs: 'text-[10px] px-1.5 py-0.5 leading-none',
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-sm px-2 py-0.5',
  };

  return (
    <span
      title={title}
      className={`inline-flex items-center gap-1 rounded font-medium border uppercase tracking-wider select-none ${variantStyles[variant]} ${sizeStyles[size]} ${className}`}
    >
      {children}
    </span>
  );
};
